export default "__VITE_ASSET__CCgSsnA$__"